module.exports = __webpack_public_path__ + "img/icon_lih.f314ce44.svg";